<v-progress-circular v-if="! loaded" :size="50" color="primary" indeterminate/><slot v-if="loaded"/>